<template>
  <div class="artic">
    <div class="article" v-if="article">
      <div class="box">
        <div class="title">{{article.title.rendered}}</div>
        <div class="line-k"></div>
        <div class="content" v-html="replaceImgHW(article.content.rendered)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'iarticle',
  data () {
    return {
      apiUrl: 'https://api.suuon.net/wp-json/wp/v2/posts/',
      article: {},
      id: this.$route.query.id
    }
  },
  created () {
    this.getArticle()
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    'this.id': 'getArticle'
  },
  methods: {
    getArticle () {
      // GET /someUrl
      this.$http.get(this.apiUrl + this.id).then(response => {
        // get body data
        response = response.body
        this.article = response
        // alert(response)
        // console.log(this.article)
        // alert(this.id)
      })
    },
    replaceImgHW (strs) {
      var st1 = strs.replace(/ height="\d+"/g, '')
      var st2 = st1.replace(/ width="\d+"/g, '')
      var st3 = st2.replace(/width: \d+px/g, '')
      var st4 = st3.replace(/ style/g, '')
      var st5 = st4.replace(/=""/g, '')
      var st = st5.replace(/href=/g, 'target="_blank" href=')
      return st
    }
  }
}
</script>
